// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/product-offering/product-offering.component.scss
// module id = 450
// module chunks = 0